
import { useEffect, useRef } from "react";
import { AnimatePresence } from "framer-motion";
import { ChatMessage } from "./ChatMessage";
import { useAgentStore } from "@/store/agentStore";
import { useAnalytics } from "@/hooks/useAnalytics";
import type { ChatMessageData } from "@/store/agentStore";
import "./ChatWindow.css";

export function ChatWindow() {
  const messages = useAgentStore((s) => s.messages);
  const current = useAgentStore((s) => s.current);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { submit } = useAnalytics();

  // Auto-scroll to bottom on new messages
  useEffect(() => {
    if (scrollRef.current) {
      setTimeout(() => {
        scrollRef.current?.scrollTo({
          top: scrollRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [messages, current?.phase]);

  return (
    <div ref={scrollRef} className="chat-window">
      {messages.length === 0 ? (
        <div className="chat-empty">
          <div className="chat-empty-icon">⚡</div>
          <div>
            <h1 className="chat-empty-title">
               <span className="accent">Xenith</span>
            </h1>
            <p className="chat-empty-desc">
              Ask anything about your data. The agent will analyze, visualize, and provide insights.
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="chat-spacer" />
          <AnimatePresence mode="popLayout">
            {messages.map((msg: ChatMessageData) => (
              <ChatMessage
                key={msg.id}
                type={msg.type}
                content={msg.content}
                result={msg.result}
                isLoading={msg.isLoading}
                clarification_questions={msg.clarification_questions}
                onClarificationAnswer={submit}
                timestamp={msg.timestamp}
              />
            ))}
          </AnimatePresence>

          {/* Loading indicator when running */}
          {current?.phase === "running" && !messages[messages.length - 1]?.isLoading && (
            <div className="chat-loading-gap" />
          )}
        </>
      )}
    </div>
  );
}
